import { Trans, useTranslation } from 'next-i18next';
import { StrongText } from '@/components/StrongText';
export const GenerateResultDescription = ({
  generatedItemsCount
}: {
  generatedItemsCount: number;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <Trans t={t} i18nKey={'ai.resultDescription.descriptionWithNumber'} values={{
    n: generatedItemsCount
  }} components={{
    Comp: <StrongText text={t('ai.resultDescription.accent')} />
  }} data-sentry-element="Trans" data-sentry-component="GenerateResultDescription" data-sentry-source-file="GenerateResultDescription.tsx" />;
};